import { render, staticRenderFns } from "./channelClient.vue?vue&type=template&id=892cfb20&scoped=true"
import script from "./channelClient.vue?vue&type=script&lang=js"
export * from "./channelClient.vue?vue&type=script&lang=js"
import style0 from "./channelClient.vue?vue&type=style&index=0&id=892cfb20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892cfb20",
  null
  
)

export default component.exports